// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileWarning_wrapper__2uHU7"};